import { render } from "./Stats.html?vue&type=template&id=237d5300&scoped=true&ts=true"
import script from "./Stats.ts?vue&type=script&lang=ts"
export * from "./Stats.ts?vue&type=script&lang=ts"

import "./Stats.css?vue&type=style&index=0&id=237d5300&scoped=true&lang=css"

import exportComponent from "/home/dev/deployment/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237d5300"]])

export default __exports__